import axios from 'axios' 
import { BUSCAR_DISPONIBILIDADES_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarDisponibilidadesVeiculo (empredaId, veiculoId) {

  let url = `${URL}/disponibilidade-veiculo/empresa/${empredaId}/veiculo/${veiculoId}`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_DISPONIBILIDADES_VEICULO,
        payload: response

      })
  );
}
